import { useEffect, useState } from 'react';

export default function useReducedMotion() {
    const [reduced, setReduced] = useState(() => typeof window !== 'undefined' && Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches));
    useEffect(() => {
        const media = window.matchMedia?.('(prefers-reduced-motion: reduce)');
        if (!media) return;
        const update = () => setReduced(media.matches);
        update();
        if (media.addEventListener) media.addEventListener('change', update);
        else media.addListener?.(update);
        return () => {
            if (media.removeEventListener) media.removeEventListener('change', update);
            else media.removeListener?.(update);
        };
    }, []);
    return reduced;
}
